"use strict";
var video = document.getElementById('seo-video');
if (video) {
    var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                video.play();
            }
            else {
                video.pause();
            }
        });
    }, {
        threshold: 0.5
    });
    videoObserver.observe(video);
}
